/**
 * DO NOT DELETE THIS FILE!
 * This file comes by default with the razzle Isomorphic template
 */

__webpack_public_path__ = window.LOCAL_PUBLIC_PATH;
